<template>
  <div>
    <top-bar :heading="'Course Results: ' + results.user.name" :buttons="buttons"></top-bar>
    <div class="container-fluid p-3">
      <loading-spinner :loading="!loaded"></loading-spinner>
      <div v-if="loaded">
        <div class="col-12 mb-4">
          <div class="row" style="justify-content: space-around;">
            <div class="col">
              <div class="dot dot__big dot__bottom dot-orange"></div>&nbsp;&nbsp;
              ASSIGNED
            </div>
            <div class="col">
              <div class="dot dot__big dot__bottom dot-blue"></div>&nbsp;&nbsp;
              ENABLED
            </div>
            <div class="col">
              <div class="dot dot__big dot__bottom dot-lime"></div>&nbsp;&nbsp;
              COMPLETE
            </div>
            <div class="col">
              <div class="dot dot__big dot__bottom dot-gold"></div>&nbsp;&nbsp;
              RPL
            </div>
            <div class="col">
              <div class="dot dot__big dot__bottom dot-teal"></div>&nbsp;&nbsp;
              CT
            </div>
            <div class="col">
              <div class="dot dot__big dot__bottom dot-yellow"></div>&nbsp;&nbsp;
              CM
            </div>
            <div class="col">
              <div class="dot dot__big dot__bottom dot-platinum"></div>&nbsp;&nbsp;
              Not Enrolled
            </div>
          </div>
        </div>

        <template v-for="course in results.courses">
          <b-card :key="course.id">
            <b-card-header v-b-toggle="'course-' + course.id" style="cursor: pointer" :header-bg-variant="getCourseBackgroundColour(course)">
              <b>{{ course.course_name }}</b>
            </b-card-header>
            <b-collapse :id="'course-' + course.id" class="mt-2">
              <b-card-body class="p-3">
                <div class="mb-3" v-if="$auth.check(['admin', 'super_admin', 'super_admin', 'rto', 'rto_trainer'])">
                  <h4 class="bold">Signoff Forms Status</h4>
                  <ul class="list">
                    <li v-for="sof in course.signoffs" :key="sof.id">
                      <span>{{ sof.form_name || 'No Form Name' }}</span>
                    </li>
                  </ul>
                  <div v-if="course.signoffs.length === 0">
                    <span class="text-red">No signoff forms sent</span>&nbsp;-&nbsp;
                    <a href="#" @click.prevent="sendSignOff(course.course_id)">Send Form/s</a>
                  </div>
                </div>
                <div>
                  <template v-for="module in course.modules">
                    <b-card :key="module.id" border-variant="primary">
                      <b-card-header v-b-toggle="'module-' + module.id" style="cursor: pointer" :header-bg-variant="getModuleBackgroundColour(module)">
                        {{ module.module.name }}
                      </b-card-header>
                      <b-collapse :id="'module-' + module.id" class="mt-2 border-primary">
                        <b-card-body>
                          <table class="table table-hover table-md-responsive">
                            <thead>
                              <tr>
                                <th></th>
                                <th>Learning Activity / Assignment</th>
                                <th>Submission Date</th>
                                <th>Graded Date</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="section in module.sections" :key="section.id">
                                <td>
                                  <font-awesome-icon class="text-success" icon="check-circle" v-if="section.is_complete"></font-awesome-icon>
                                  <font-awesome-icon class="text-warning" icon="exclamation-circle" v-if="!section.is_complete"></font-awesome-icon>
                                </td>
                                <td>{{ section.section.name }}</td>
                                <template v-if="section.section.form_id">
                                  <!-- Submitted Date -->
                                  <td v-if="!section.submission"> -</td>
                                  <td v-else>{{ section.submission.created_at | moment('ddd Do MMM, YYYY') }}</td>
                                  <!-- Graded Date -->
                                  <td v-if="!section.submission"> -</td>
                                  <td v-else>{{ section.submission.graded_at | moment('ddd Do MMM, YYYY') }}</td>
                                  <!-- Status -->
                                  <td v-if="!section.submission"> -</td>
                                  <td v-else-if="section.submission.grade_status === 0" class="text-danger">NOT SATISFACTORY</td>
                                  <td v-else-if="section.submission.grade_status === 1" class="text-success">SATISFACTORY</td>
                                  <td v-else-if="section.submission.grade_status === 2" class="text-warning">UNGRADED</td>
                                  <!-- Action -->
                                  <td v-if="!section.submission"> -</td>
                                  <td v-if="section.submission">
                                    <router-link :to="'/submissions/' + section.submission.id">Preview</router-link>
                                  </td>
                                </template>
                                <template v-else>
                                  <td colspan="4">No Assignment Required</td>
                                </template>
                              </tr>
                            </tbody>
                          </table>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                  </template>
                </div>

              </b-card-body>
            </b-collapse>
          </b-card>

        </template>

      </div> <!-- /.row -->
    </div>

  </div>
</template>

<script>

export default {
  name: 'CourseResults',
  data () {
    return {
      results: {
        user: {},
        courses: {}
      },
      loaded: false,
      buttons: [
        { label: 'Edit User', 'url': '/users/' + this.id },
        { label: 'Training Plan', 'url': '/users/' + this.id + '/training_plan', access: this.$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin', 'super_admin']) },
        { label: 'Progression', url: '/users/' + this.id + '/progression' },
        //{label: 'Results', url: '/results/' + this.id + '/results'}
        { label: 'Export Results to PDF', 'click': this.exportResults, access: this.$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin']) }
      ]
    }
  },
  methods: {
    loadResults () {
      this.axios.get('/students/' + this.id + '/results').then(rsp => {
        this.results = rsp.data
        this.loaded = true
      }).catch(err => this.$snotify.error(err.response.data.message, 'Results Error'))
    },
    sendSignOff (id) {
      this.axios.get('/signoff/send?student_id=' + this.id + '&course_id=' + id).then(() => {
        this.$swal('Success', 'Form Sent', 'success')
        this.loadResults()
        this.$store.dispatch('LOAD_MY_SIGNOFF_FORMS', this)
      }).catch(err => this.$snotify.error(err.response.data.message, 'Sign Off Error'))
    },
    getCourseBackgroundColour (user_course) {
      if (!user_course.is_enrolled) return 'platinum'
      if (user_course.has_rpl) return 'gold'
      if (user_course.has_credit_transfer) return 'teal'
      if (user_course.is_complete_manual) return 'yellow'
      if (user_course.is_completed) return 'lime'
      if (user_course.is_enabled) return 'blue'
      if (user_course.is_enrolled) return 'orange'
      return 'platinum'
    },
    getModuleBackgroundColour (user_module) {
      if (user_module.is_complete) return 'lime'
      if (user_module.is_enabled) return 'blue'
      return 'blue'
    },
    exportResults () {
      this.axios.get('/students/' + this.id + '/results/pdf').then(rsp => {
        this.$swal('Success', rsp.data.message, 'success')
      })
    }
  },
  mounted () {
    console.log(this.$metaInfo, this.$metadata)
    this.loadResults()
  },
  metaInfo: {
    title: 'Course Results'
  },
  props: ['id']
}
</script>
